import { Api } from 'utils';

class NotificationService {


    static admin = {
        get: async (params?: any) => Api.createResponse('admin/notifications/get', params),
        create: async (params?: any) => Api.createResponse('admin/notifications/create', params),
        delete: async (params?: any) => Api.createResponse('admin/notifications/delete', params),
    }


}

export default NotificationService;